//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/* eslint new-cap: ["error", { "capIsNewExceptions": ["Event"] }] */
import searchFilterSemanticTagsSearchBarTemplate from '@legacy-components/filters/search-filter-semantic-tags-search-bar.html';
import semanticSearchTagTemplate from '@partials/semantic-search-tag.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.component('searchFilterSemanticTagsSearchBar', {
    template: searchFilterSemanticTagsSearchBarTemplate,
    bindings: {
      placeholderText: '@',
      includeStateFilter: '<',
      trackingCategory: '@',
      autocompleteCallback: '&',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    controllerAs: '$semanticTagsSearch',
    controller: [
      '$scope',
      '$timeout',
      'ContentFilterTypes',
      function(
        $scope,
        $timeout,
        ContentFilterTypes,
      ) {
        const self = this;

        $scope.model = {
          searchTerm: null,
          loading: false,
          currentRequest: null,
        };

        const addFilter = function(filterObj) {
          const alias = filterObj.value.toLowerCase();
          self.searchFilter.addValue({ value: filterObj.value, aliasKey: filterObj.value });
          self.searchFilter.registerFilterOptionAlias(filterObj.value, alias);
          $timeout(() => {
            $scope.$broadcast('twitter-typeahead:reset');
          }, 0);
        };

        $scope.model.typeaheadConfig = {
          events: {
            enterKeyed($event, obj) {
              if (!_.isUndefined(obj) && !_.isNull(obj)) {
                addFilter(obj);
              }
            },
            focus() {
              const typeaheadElem = this;
              const e = angular.element.Event('keydown.tt');
              e.which = 38;
              typeaheadElem.trigger(e);
            },
          },
          context: {
            addFilter,
          },
          setKeys: ['tags', 'users'],
          templateSets: {
            pre: {
              empty: { html: '<div ng-show="isEmpty" class="empty-set"><em>No matches found</em></div>' },
            },
            tags: {
              header: {
                html:
                                    '<h6 ng-show="!isEmpty" class="subhead">' +
                                        '{{ (!query) ? \'Top Visual Tags\' : \'Matching Visual Tags\' }}' +
                                    '</h6>',
              },
              suggestion: { html: semanticSearchTagTemplate },
            },
          },
          getData: _.debounce((query, defer) => {
            $scope.model.loading = true;
            if ($scope.model.currentRequest) {
              $scope.model.currentRequest.abort();
            }

            $scope.model.currentRequest = self.autocompleteCallback({ query });
            $scope.model.currentRequest.then((results) => {
              if (results) {
                defer.resolve({
                  tags: _(results.tags)
                  .sortBy(tag => -tag.count)
                  .map((t) => {
                    return {
                      type: ContentFilterTypes.SEMANTIC_TAG,
                      value: t.tag,
                      count: t.count,
                    };
                  }),
                });
              }
            }).finally(() => {
              $scope.model.loading = false;
              $scope.model.currentRequest = null;
            });
          }, 300),

        };

        this.$onInit = function() {
          $scope.model.locked = self.searchFilter.isKeyLocked();
        };

        $scope.$on('social-search-bar:clear', () => {
          const currentSearchFilterValue = self.searchFilter.getValue();
          if (currentSearchFilterValue && !!currentSearchFilterValue.length) {
            self.searchFilter.setValues([]);
          }
        });
      },
    ],
  });
})();
